export const ReceivedPaymentStatus = {
  MATCHED: 'MATCHED',
  UNMATCHED: 'UNMATCHED',
  PENDING: 'PENDING',
} as const;

export type ReceivedPaymentStatus =
  (typeof ReceivedPaymentStatus)[keyof typeof ReceivedPaymentStatus];

export type LegacyQrPaymentType = 'service' | 'products';

export type ReceivedPaymentMatchedVisit = {
  id: string;
  date: string;
  client: {
    id: string;
    firstName: string | null;
    lastName: string;
  };
};

export type ReceivedPayment = {
  id: string;
  amount: string;
  currency: string;
  variableSymbol: string | null;
  counterAccount: string | null;
  payerName: string | null;
  message: string | null;
  receivedAt: string;
  status: ReceivedPaymentStatus;
  matchedVisitId: string | null;
  paymentType: QrPaymentType | LegacyQrPaymentType | null;
  createdAt: string;
  matchedVisit: ReceivedPaymentMatchedVisit | null;
};

export type SyncReceivedPaymentsResult = {
  failed: number;
  skipped: boolean;
  alreadyProcessed: number;
  fetched: number;
  parsed: number;
  matched: number;
  unmatched: number;
};

export type QrPaymentType = 'deposit' | 'servicesAndProducts' | 'additional';

export type PaymentQr = {
  qrDataUrl: string;
  spayd: string;
  variableSymbol: string;
  amount: number;
  account: string;
  type: QrPaymentType;
};
